import { createI18n } from 'vue-i18n';
import en from './language/en';
import id from './language/id';
import ms from './language/ms';
import th from './language/th';
import vi from './language/vi';
import LangManager from './lang-manager';

LangManager.init();


export default () => createI18n({
  locale: LangManager.get(),
  legacy: false,
  globalInjection: true,
  messages: {
    en,
    id,
    ms,
    th,
    vi,
  },
});
